/**
 * Nested contextual fields rendered under a selected radio filter option
 * (e.g. date range or days-remaining editors).
 */
import { useRmaListFilterRadioGroup } from "../rma-list-filter-radio-group-context";
import type { IRmaListFilterRadioOption } from "../rma-list-filter-radio-option";

interface IProps {
    option: IRmaListFilterRadioOption;
}

const ContextualFields: React.FC<IProps> = ({ option }) => {
    const { value } = useRmaListFilterRadioGroup();
    const selected = value === option.id;

    if (!selected || option.contextualFields == null) {
        return null;
    }

    return (
        <div className="rma-list-filter-radio-option__content">
            {option.contextualFields}
        </div>
    );
};

export default ContextualFields;
